import { ButtonDataProps } from '../../props/buttondataprops'
import Button from '../button/Button'
import HorizontalSpace from '../util/HorizontalSpace'


interface NavigationArrowsProps {
	btnDatas: ButtonDataProps[],
	language: string,
	isDarkTheme: boolean
}


function NavigationArrows({btnDatas, language, isDarkTheme}: Readonly<NavigationArrowsProps>) {

	return (
		<>
			{
				btnDatas &&
				btnDatas.length > 0 &&
				<>
					{
						btnDatas.map((btnData, btnDatasIndex) => {
							return (
								<span key={"arrow-" + btnDatasIndex}>
									<Button btnData={btnData} language={language} isDarkTheme={isDarkTheme} />
									<HorizontalSpace />
								</span>
							)
						})
					}
				</>
			}
		</>
	)
}

export default NavigationArrows